// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5cb71da3","732":"bd53abe2","977":"475a8139"}[chunkId] + ".chunk.js";
};